import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './prepaidCard.module.scss';

import dictionary from 'config/dictionary';

const CopyableDetail = ({ label, detail, copyable = true }) => {
  const [isCopied, setIsCopied] = useState(false);

  const onCopyClick = () => {
    navigator.clipboard.writeText(detail);

    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <div className={styles.copyableDetailOuterContainer}>
      <div className={styles.copyableDetailLabelContainer}>
        <p className={styles.copyableDetailLabel}>{label}</p>
      </div>
      <div className={styles.copyableDetailContainer}>
        <div className={styles.copyableDetailLabelDetailContainer}>
          <p className={styles.copyableDetailDetail}>{detail}</p>
        </div>
        <div className={styles.copyableDetailCopyContainer}>
          {copyable && <>
            <button className={styles.copyableDetailCopyButton} onClick={onCopyClick}>{dictionary.prepaidCards.labels.copy}</button>
            <div className={classnames(styles.copiedTooltip, isCopied ? styles.copied : '')}>
              Copied
            </div>
          </>}
        </div>
      </div>
    </div>
  );
};

CopyableDetail.propTypes = {
  label: PropTypes.string.isRequired,
  copyable: PropTypes.bool,
  detail: PropTypes.node.isRequired,
};

export default CopyableDetail;
